@if (performance) {
  <div class="button-with-dot">
    <ion-button (click)="showLog()"
                [color]="isLogConcept() ? 'medium': ''"
                [fill]="hasLog() ? 'solid' : 'clear'"
                class="multiline-label"
                expand="block">
      @if (isLogConcept()) {
        {{ 'performanceCard.logButton.concept' | translate }}
      } @else if (!hasLog()) {
        {{ 'performanceCard.logButton.empty' | translate }}
      } @else {
        {{ 'performanceCard.logButton.view' | translate }}
      }
    </ion-button>
    @if (hasUnseenChange) {
      <span class="change-dot" aria-label="Gewijzigd sinds je het laatst zag"></span>
    }
  </div>
  <span class="name crew-name"
        [class.crew-name--unassigned]="!performance.showreport && !performance.log">
    {{ performance | getUserFullNameFromPerformanceWithRole: CrewRole.toneelmeester }}
  </span>
}
